import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabservicepunetomumbai() {



  const cardData = {


  keyword: "Best Cab Service Pune to Mumbai",

  headingDescription: "Trustline Travels offers the best cab service Pune to Mumbai with reliable, safe, and affordable taxi solutions for business travel, airport transfers, corporate meetings, family vacations, medical visits, and outstation journeys. Whether you need a one-way cab, round-trip taxi, or customized travel package, our professional chauffeurs ensure punctual pickups and a comfortable travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement and budget. With transparent pricing, doorstep pickup, easy online booking, well-maintained cars, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Mumbai taxi services.",

  topPlaces: [
    {
      title: "BKC (Bandra Kurla Complex)",
      description: "Bandra Kurla Complex is Mumbai's premier financial and commercial district, home to multinational corporations, banking headquarters, government offices, luxury hotels, and world-class convention centers. It is one of the most preferred destinations for corporate travelers, business executives, and professionals visiting Mumbai from Pune."
    },
    {
      title: "Andheri East",
      description: "Andheri East is one of Mumbai's largest commercial hubs, featuring IT parks, corporate offices, business hotels, industrial estates, and seamless connectivity to Mumbai International Airport. It is a preferred destination for business meetings, conferences, and professional travel."
    },
    {
      title: "Powai",
      description: "Powai is a thriving business and residential destination known for Hiranandani Business Park, multinational companies, technology firms, premium hotels, and educational institutions. It attracts corporate professionals, entrepreneurs, and visitors throughout the year."
    },
    {
      title: "Airoli",
      description: "Airoli is a prominent IT and business hub in Navi Mumbai, housing leading software companies, financial institutions, research centers, and corporate campuses. It is widely visited by professionals traveling for meetings, training programs, and business operations."
    },
    {
      title: "Jio World Convention Centre",
      description: "Jio World Convention Centre is one of India's most prestigious venues for international exhibitions, business conferences, product launches, trade fairs, and corporate events. It regularly hosts large-scale national and global business gatherings."
    },
    {
      title: "NESCO Exhibition Centre",
      description: "NESCO Exhibition Centre in Goregaon is a renowned venue for trade shows, industrial expos, corporate events, and international exhibitions. It attracts exhibitors, entrepreneurs, and business visitors from across India and overseas."
    },
    {
      title: "Gateway of India",
      description: "Gateway of India is Mumbai's most iconic historical monument overlooking the Arabian Sea. Visitors enjoy its magnificent architecture, scenic waterfront, ferry rides to Elephanta Caves, and the vibrant atmosphere surrounding this famous landmark."
    },
    {
      title: "Marine Drive",
      description: "Marine Drive, popularly known as the Queen's Necklace, is a world-famous seaside boulevard offering breathtaking sunset views, relaxing evening walks, and spectacular views of Mumbai's illuminated skyline along the Arabian Sea."
    },
    {
      title: "Elephanta Caves",
      description: "Elephanta Caves is a UNESCO World Heritage Site featuring remarkable rock-cut temples, ancient sculptures, and centuries-old carvings dedicated to Lord Shiva. It is one of Mumbai's most visited cultural and historical attractions."
    },
    {
      title: "Colaba Causeway",
      description: "Colaba Causeway is one of Mumbai's most vibrant shopping and cultural destinations, offering fashion boutiques, handicrafts, cafés, restaurants, and colonial-era architecture. It is a favorite stop for tourists exploring South Mumbai."
    }
  ],






"services": [
  {
    "name": "Best Cab Service Pune to Mumbai",
    "description": "Book the Best Cab Service Pune to Mumbai for safe, comfortable, and affordable travel with professional chauffeurs, clean AC vehicles, transparent pricing, doorstep pickup, and 24x7 customer support. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cars for business, family, and airport travel."
  },
  {
    "name": "Pune to Mumbai Cab Service",
    "description": "Our Pune to Mumbai Cab Service offers reliable one-way and round-trip travel with experienced drivers, sanitized vehicles, fixed fares, timely pickup, and comfortable intercity transportation."
  },
  {
    "name": "Pune to Mumbai Cab",
    "description": "Book Pune to Mumbai Cab with chauffeur-driven AC vehicles, affordable pricing, flexible pickup, and smooth travel for business trips, family vacations, and corporate travel."
  },
  {
    "name": "Pune to Mumbai Taxi Service",
    "description": "Choose Pune to Mumbai Taxi Service for reliable transportation with professional drivers, premium cars, transparent pricing, and comfortable long-distance travel."
  },
  {
    "name": "Pune to Mumbai Taxi",
    "description": "Reserve Pune to Mumbai Taxi with clean AC vehicles, experienced chauffeurs, fixed fares, and dependable intercity service."
  },
  {
    "name": "Pune to Mumbai Cab Booking",
    "description": "Complete your Pune to Mumbai Cab Booking with instant confirmation, multiple vehicle choices, affordable fares, and doorstep pickup."
  },
  {
    "name": "Online Pune to Mumbai Cab Booking",
    "description": "Use Online Pune to Mumbai Cab Booking for secure reservations, instant confirmation, transparent pricing, and professional chauffeur service."
  },
  {
    "name": "Book Pune to Mumbai Cab",
    "description": "Book Pune to Mumbai Cab anytime with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for comfortable and hassle-free travel."
  },
  {
    "name": "Pune to Mumbai One Way Cab",
    "description": "Choose Pune to Mumbai One Way Cab and pay only for your single journey while enjoying comfortable vehicles, experienced drivers, and affordable fares."
  },
  {
    "name": "Pune to Mumbai Round Trip Cab",
    "description": "Book Pune to Mumbai Round Trip Cab with flexible return timing, premium vehicles, transparent pricing, and reliable service."
  },
  {
    "name": "Pune to Mumbai Outstation Cab",
    "description": "Travel comfortably with Pune to Mumbai Outstation Cab featuring AC vehicles, professional chauffeurs, safe highway travel, and dependable service."
  },
  {
    "name": "Pune to Mumbai Car Rental",
    "description": "Choose Pune to Mumbai Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for family and corporate travel."
  },
  {
    "name": "Pune to Mumbai AC Cab",
    "description": "Book Pune to Mumbai AC Cab with well-maintained air-conditioned vehicles, comfortable seating, and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Intercity Cab",
    "description": "Our Pune to Mumbai Intercity Cab service offers affordable fares, premium vehicles, punctual pickup, and professional chauffeurs."
  },
  {
    "name": "Pune to Mumbai Travel Cab",
    "description": "Book Pune to Mumbai Travel Cab for business trips, family vacations, airport transfers, and weekend journeys with reliable taxi service."
  },
  {
    "name": "Pune to Mumbai Drop Taxi",
    "description": "Choose Pune to Mumbai Drop Taxi for direct destination drop with transparent pricing, clean AC vehicles, and experienced chauffeurs."
  },
  {
    "name": "Pune to Mumbai Cab Hire",
    "description": "Hire Pune to Mumbai Cab with premium chauffeur-driven vehicles, affordable pricing, and dependable customer support."
  },
  {
    "name": "Pune Mumbai Taxi Service",
    "description": "Book Pune Mumbai Taxi Service for one-way, round-trip, business, and family travel with clean vehicles and professional drivers."
  },
  {
    "name": "Innova Crysta Pune to Mumbai Cab",
    "description": "Travel in comfort with Innova Crysta Pune to Mumbai Cab offering spacious seating, premium interiors, luggage space, and professional chauffeurs."
  },
  {
    "name": "Ertiga Pune to Mumbai Cab",
    "description": "Choose Ertiga Pune to Mumbai Cab for affordable family travel with comfortable seating, AC comfort, and reliable intercity transportation."
  },
  {
    "name": "Sedan Pune to Mumbai Cab",
    "description": "Book Sedan Pune to Mumbai Cab for economical travel with chauffeur-driven vehicles, comfortable seating, and fixed pricing."
  },
  {
    "name": "Kia Carens Pune to Mumbai Cab",
    "description": "Reserve Kia Carens Pune to Mumbai Cab for spacious family travel with premium comfort, luggage space, and experienced drivers."
  },
  {
    "name": "Swift Dzire Pune to Mumbai Cab",
    "description": "Book Swift Dzire Pune to Mumbai Cab with affordable fares, clean AC vehicles, and reliable chauffeur service."
  },
  {
    "name": "Hyundai Aura Pune to Mumbai Cab",
    "description": "Choose Hyundai Aura Pune to Mumbai Cab for budget-friendly intercity travel with professional drivers and comfortable rides."
  },
  {
    "name": "SUV Cab Pune to Mumbai",
    "description": "Book SUV Cab Pune to Mumbai for group travel, family vacations, business trips, and comfortable long-distance journeys."
  }
],

"tableData": [
  ["Best Cab Service Pune to Mumbai", "Pune to Mumbai Cab Service"],
  ["Pune to Mumbai Cab", "Pune to Mumbai Taxi Service"],
  ["Pune to Mumbai Taxi", "Pune to Mumbai Cab Booking"],
  ["Online Pune to Mumbai Cab Booking", "Book Pune to Mumbai Cab"],
  ["Pune to Mumbai One Way Cab", "Pune to Mumbai Round Trip Cab"],
  ["Pune to Mumbai Outstation Cab", "Pune to Mumbai Car Rental"],
  ["Pune to Mumbai AC Cab", "Pune to Mumbai Intercity Cab"],
  ["Pune to Mumbai Travel Cab", "Pune to Mumbai Drop Taxi"],
  ["Pune to Mumbai Cab Hire", "Pune Mumbai Taxi Service"],
  ["Innova Crysta Pune to Mumbai Cab", "Ertiga Pune to Mumbai Cab"],
  ["Sedan Pune to Mumbai Cab", "Kia Carens Pune to Mumbai Cab"],
  ["Swift Dzire Pune to Mumbai Cab", "Hyundai Aura Pune to Mumbai Cab"],
  ["SUV Cab Pune to Mumbai", ""]
],





whychoose: [
  {
    WhyChooseheading: "Best Cab Service Pune to Mumbai",
    WhyChoosedescription: "Trustline Travels delivers one of the best cab services from Pune to Mumbai with reliable transportation, professional drivers, and comfortable vehicles for every journey."
  },
  {
    WhyChooseheading: "Safe & Comfortable Long-Distance Travel",
    WhyChoosedescription: "Every trip is planned with passenger comfort and safety in mind, ensuring a smooth ride through the Mumbai-Pune Expressway."
  },
  {
    WhyChooseheading: "Fleet for Every Travel Requirement",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers suitable for solo travelers, families, and corporate groups."
  },
  {
    WhyChooseheading: "Affordable Fares with Complete Transparency",
    WhyChoosedescription: "Trustline Travels offers competitive pricing with clear fare details, ensuring there are no hidden charges during your Pune to Mumbai journey."
  },
  {
    WhyChooseheading: "Doorstep Pickup & Convenient Drop",
    WhyChoosedescription: "Our cab service includes pickup from any location in Pune and drop-off anywhere in Mumbai, including airports, hotels, offices, and residential areas."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round-Trip Options",
    WhyChoosedescription: "Book one-way cabs, return journeys, or customized travel packages according to your travel schedule and budget."
  },
  {
    WhyChooseheading: "Suitable for Every Travel Purpose",
    WhyChoosedescription: "Whether it's airport transfers, corporate meetings, family vacations, medical visits, or leisure travel, we have the right cab solution."
  },
  {
    WhyChooseheading: "Easy Online Booking & 24/7 Customer Support",
    WhyChoosedescription: "Book your Pune to Mumbai cab in minutes with instant confirmation and round-the-clock customer assistance."
  }
]

};

const faqData = [
  {
    question: "Why is Trustline Travels considered one of the best cab services from Pune to Mumbai?",
    answer: "Trustline Travels is known for punctual service, comfortable vehicles, experienced drivers, transparent pricing, and reliable customer support."
  },
  {
    question: "Can I book a one-way cab from Pune to Mumbai?",
    answer: "Yes, we provide affordable one-way cab services as well as round-trip packages from Pune to Mumbai."
  },
  {
    question: "Which cars are available for Pune to Mumbai travel?",
    answer: "Our fleet includes Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to suit different travel requirements."
  },
  {
    question: "Do you provide pickup from Pune Airport and Pune Railway Station?",
    answer: "Yes, we offer doorstep pickup from Pune Airport, Pune Railway Station, hotels, offices, and residential locations."
  },
  {
    question: "Is your cab service available 24 hours?",
    answer: "Yes, Trustline Travels operates 24/7, making it convenient to travel at any time of the day or night."
  },
  {
    question: "Can I book a cab for Mumbai Airport?",
    answer: "Yes, we provide direct cab services from Pune to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in your booking quotation."
  },
  {
    question: "Is advance booking recommended?",
    answer: "Yes, advance booking helps secure your preferred vehicle and pickup timing, especially during weekends and holidays."
  },
  {
    question: "Do you provide cabs for business and family travel?",
    answer: "Yes, our Pune to Mumbai cab service is ideal for corporate travel, family trips, airport transfers, sightseeing, and personal journeys."
  },
  {
    question: "How can I book the best cab service from Pune to Mumbai with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Kulshrestha",
    feedback: "Trustline Travels consistently delivers excellent service with clean vehicles, punctual pickups, and courteous drivers. The journey from Pune to Mumbai was comfortable, efficient, and professionally managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Rutuja Patankar",
    feedback: "Exceptional travel experience backed by transparent pricing and outstanding customer support. The vehicle quality, driving standards, and timely arrival made Trustline Travels a dependable choice for intercity travel.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service Pune to Mumbai",
  "image": "https://www.trustlinetravels.com/assets/images/best-cab-service-pune-to-mumbai.webp",
  "description": "Book the best cab service Pune to Mumbai with Trustline Travels for safe, comfortable, and reliable intercity travel. Get premium one-way, round-trip, airport, and outstation taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8129"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/best-cab-service-pune-to-mumbai"
  }
};






  return (
    <div>
<Helmet>
  <title>Best Cab Service Pune to Mumbai | Reliable Taxi Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book the best cab service Pune to Mumbai with Trustline Travels. Enjoy reliable Pune Mumbai taxi services with one-way, round-trip, airport, and outstation cab options including Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7."
  />

  <meta
    name="keywords"
    content="Best cab service pune to mumbai, Best cab service mumbai to pune, Best cab service from mumbai airport to pune, Best cab service from pune to mumbai airport, Best mumbai pune cab service, Best pune to mumbai cab service, Best Cab Service Pune to Mumbai, Pune to Mumbai Cab Service, Pune to Mumbai Cab, Pune to Mumbai Taxi, Pune Mumbai airport cab, Pune Mumbai one way taxi, Pune Mumbai round trip cab booking, Pune Mumbai outstation taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/87.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabservicepunetomumbai;